import { cn } from '@/lib/utils';

const statusConfig = {
  online: { color: 'bg-emerald-500', label: 'Online', textColor: 'text-emerald-600' },
  suspect: { color: 'bg-amber-500', label: 'Suspect', textColor: 'text-amber-600' },
  vape: { color: 'bg-red-500 animate-pulse', label: 'VAPE', textColor: 'text-red-600' },
  offline: { color: 'bg-slate-400', label: 'Offline', textColor: 'text-slate-500' },
};

export function StatusIndicator({ status, size = 'default', showLabel = false }) {
  const config = statusConfig[status] || statusConfig.offline;
  
  const sizeClasses = {
    sm: 'h-2 w-2',
    default: 'h-3 w-3',
    lg: 'h-4 w-4',
  };

  return (
    <div className="flex items-center gap-2">
      <span 
        className={cn(
          "rounded-full",
          sizeClasses[size],
          config.color,
          status === 'vape' && 'shadow-lg shadow-red-500/50'
        )}
        data-testid={`status-indicator-${status}`}
      />
      {showLabel && (
        <span className={cn("text-xs font-ibm font-semibold uppercase tracking-wide", config.textColor)}>
          {config.label}
        </span>
      )}
    </div>
  );
}

export function StatusBadge({ status }) {
  const config = statusConfig[status] || statusConfig.offline;
  
  const bgColors = {
    online: 'bg-emerald-100 text-emerald-700 border-emerald-200',
    suspect: 'bg-amber-100 text-amber-700 border-amber-200',
    vape: 'bg-red-100 text-red-700 border-red-200 animate-pulse',
    offline: 'bg-slate-100 text-slate-600 border-slate-200',
  };

  return (
    <span 
      className={cn(
        "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-sm text-xs font-ibm font-semibold uppercase tracking-wide border",
        bgColors[status]
      )}
      data-testid={`status-badge-${status}`}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", config.color)} />
      {config.label}
    </span>
  );
}
